module.exports = __webpack_public_path__ + "img/change.12dd9ddb.jpg";